import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getLanguageList from '../../services/language/getLanguageList'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchLanguages () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const languagesCombo = yield call(getLanguageList, auth.token)
    yield put(fetchCombosSuccess({ languagesCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchLanguages () {
  yield takeLatest(combosActionTypes.FETCH_LANGUAGES_COMBO, fetchLanguages)
}
